import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CreateComponent } from "../create/create.component";
import { ThemeService } from "src/app/shared/theme.service";
import { FormControl } from "@angular/forms";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  userName: any;
  darkTheme = new FormControl(true);
  isApiGroupForm: boolean;

  constructor(
    public dialog: MatDialog,
    public route: Router,
    private themeService: ThemeService,
    private token: LstorageService
  ) {
    if (token.getTheme()) {
      var theme = token.getTheme().lightbg;
      if (token.getTheme().lightbg.includes("f6f9fb")) {
        this.darkTheme = new FormControl(false);
      }
    }
    this.darkTheme.valueChanges.subscribe((value) => {
      if (value) {
        this.themeService.toggleDark();
      } else {
        this.themeService.toggleLight();
      }
    });
  }

  ngOnInit() {
    this.userName = jwtDecode(this.token.getToken());
  }

  openModal(d): void {
    const dialogRef = this.dialog.open(CreateComponent, {
      //   width: '250px',
      data: { message: "hi" },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  logout(d): void {
    this.token.saveToken("", "");
    this.route.navigate(["/login"]);
  }
}
